import {
  EMPLOYMENT_ACTION_PLAN_ADD_NEW,
  EMPLOYMENT_ACTION_PLAN_ADD_NEW_SUCCESS,
  EMPLOYMENT_ACTION_PLAN_ADD_NEW_ERROR,
  EMPLOYMENT_ACTION_PLAN_DELETE,
  EMPLOYMENT_ACTION_PLAN_DELETE_ERROR,
  EMPLOYMENT_ACTION_PLAN_DELETE_SUCCESS,
  EMPLOYMENT_ACTION_PLAN_EDIT,
  EMPLOYMENT_ACTION_PLAN_EDIT_ERROR,
  EMPLOYMENT_ACTION_PLAN_EDIT_SUCCESS,
  EMPLOYMENT_ACTION_PLAN_GET_BY_ID,
  EMPLOYMENT_ACTION_PLAN_GET_BY_ID_ERROR,
  EMPLOYMENT_ACTION_PLAN_GET_BY_ID_SUCCESS,
  EMPLOYMENT_ACTION_PLAN_GET_LIST,
  EMPLOYMENT_ACTION_PLAN_GET_LIST_ERROR,
  EMPLOYMENT_ACTION_PLAN_GET_LIST_SUCCESS,
  EMPLOYMENT_ACTION_PLAN_ADD_NEW_REQUEST,
  EMPLOYMENT_ACTION_PLAN_QUERY,
  EMPLOYMENT_ACTION_PLAN_QUERY_SUCCESS,
  EMPLOYMENT_ACTION_PLAN_QUERY_ERROR,
  EMPLOYMENT_ACTION_PLAN_BY_CLIENT,
  EMPLOYMENT_ACTION_PLAN_BY_CLIENT_SUCCESS,
  EMPLOYMENT_ACTION_PLAN_BY_CLIENT_ERROR,
  EMPLOYMENT_ACTION_PLAN_NOTIFICATION_CLOSED,
} from '../actions';

const initialState = {
  employmentActionPlans: [],
  employmentActionPlan: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
  showNotification: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case EMPLOYMENT_ACTION_PLAN_GET_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case EMPLOYMENT_ACTION_PLAN_BY_CLIENT_SUCCESS:
    case EMPLOYMENT_ACTION_PLAN_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        employmentActionPlan: payload,
      };

    case EMPLOYMENT_ACTION_PLAN_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case EMPLOYMENT_ACTION_PLAN_QUERY:
    case EMPLOYMENT_ACTION_PLAN_GET_LIST:
    case EMPLOYMENT_ACTION_PLAN_BY_CLIENT:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case EMPLOYMENT_ACTION_PLAN_QUERY_SUCCESS:
    case EMPLOYMENT_ACTION_PLAN_GET_LIST_SUCCESS:
      return {
        ...state,
        employmentActionPlans: payload,
        loading: false,
      };
    case EMPLOYMENT_ACTION_PLAN_ADD_NEW:
      return {
        ...state,
        loading: true,
        error: null,
        addSuccess: false,
      };

    case EMPLOYMENT_ACTION_PLAN_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        employmentActionPlan: payload,
        employmentActionPlans: state.employmentActionPlans.concat(payload),
        addSuccess: true,
        showNotification: true,
      };

    case EMPLOYMENT_ACTION_PLAN_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case EMPLOYMENT_ACTION_PLAN_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        employmentActionPlans: state.employmentActionPlans.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        employmentActionPlan: payload,
        error: null,
        editSuccess: true,
      };
    case EMPLOYMENT_ACTION_PLAN_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: false,
      };
    case EMPLOYMENT_ACTION_PLAN_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        employmentActionPlans: state.employmentActionPlans.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case EMPLOYMENT_ACTION_PLAN_NOTIFICATION_CLOSED:
      return {
        ...state,
        showNotification: false,
      };
    case EMPLOYMENT_ACTION_PLAN_QUERY_ERROR:
    case EMPLOYMENT_ACTION_PLAN_DELETE_ERROR:
    case EMPLOYMENT_ACTION_PLAN_ADD_NEW_ERROR:
    case EMPLOYMENT_ACTION_PLAN_EDIT_ERROR:
    case EMPLOYMENT_ACTION_PLAN_GET_BY_ID_ERROR:
    case EMPLOYMENT_ACTION_PLAN_GET_LIST_ERROR:
    case EMPLOYMENT_ACTION_PLAN_BY_CLIENT_ERROR:
      return {
        ...state,
        loading: true,
        error: payload,
      };

    default:
      return { ...state };
  }
};
